import React, { ElementType, FC } from 'react';
import cls from 'classnames';

import {
	OneStringProps,
	OneStringColor,
	OneStringTextStyle,
	OneStringAlignment,
} from './OneString.types';

const colorMap = {
	[OneStringColor.lead]: 'text-onSurface',
	[OneStringColor.supporting]: 'text-onSurfaceVariant',
	[OneStringColor.inverse]: 'text-inverseOnSurface',
};

const alignmentMap = {
	[OneStringAlignment.left]: 'text-left',
	[OneStringAlignment.center]: 'text-center',
	[OneStringAlignment.right]: 'text-right',
};

const OneString: FC<OneStringProps> & {
	TextStyle: typeof OneStringTextStyle;
	Color: typeof OneStringColor;
	Alignment: typeof OneStringAlignment;
} = (props) => {
	const {
		textStyle,
		color = OneStringColor.lead,
		alignment = OneStringAlignment.left,
		children,
		className,
	} = props;
	const Tag = (props.tag || 'p') as unknown as ElementType;

	return (
		<Tag className={cls(textStyle, colorMap[color], alignmentMap[alignment], className)}>
			{children}
		</Tag>
	);
};

OneString.displayName = 'OneString';
OneString.TextStyle = OneStringTextStyle;
OneString.Color = OneStringColor;
OneString.Alignment = OneStringAlignment;

export default OneString;
